import React from "react";
import { Helmet } from "react-helmet";

// Types & Interfaces:
import { Lang } from "../../i18n/content";

interface Props {
    lang: Lang;
}

const HtmlLang: React.SFC<Props> = ({ lang }) => (
    <Helmet
        htmlAttributes={{
            lang,
        }}
    />
);

export default HtmlLang;
